import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Candidate } from '@app/shared/models/candidate';
import { createReducer, on } from '@ngrx/store';
import {
  deleteCandidate,
  loadAiSummariesSuccess,
  loadCandidates,
  loadCandidatesSuccess,
  loadCandidatesError,
  resetCandidatesState,
  setStatusId,
} from './candidates.actions';
import {
  getPaginationInitialState,
  handleLoading,
  handleLoadingItemsSuccessWithSetAll,
  handleRemoveOneAction,
  PaginationState,
  resetPaginationState,
} from '@app/shared/pagination-adapter/pagination-adapter';
import {
  loadChatbotResults,
  loadChatbotResultsError,
  loadChatbotResultsSuccess,
} from '@app/collections/chatbot/chatbot.actions';

export interface CandidatesState extends PaginationState<Candidate> {
  candidateSummaries: Record<string, string>;
  statusId: number | null;
}

export const candidatesAdapter: EntityAdapter<Candidate> = createEntityAdapter<Candidate>({
  selectId: (candidate: Candidate) => candidate.id,
  sortComparer: false,
});

export const initialState: CandidatesState = {
  ...getPaginationInitialState(candidatesAdapter),
  candidateSummaries: {},
  statusId: null,
};

export const candidatesReducer = createReducer(
  initialState,
  on(loadCandidates, loadChatbotResults, (state) => handleLoading<CandidatesState>(state)),
  on(loadCandidatesSuccess, loadChatbotResultsSuccess, (state, { payload }) => {
    const updatedState = handleLoadingItemsSuccessWithSetAll<CandidatesState, Candidate>(
      state,
      payload.candidatesPage,
      candidatesAdapter,
    );
    return { ...updatedState };
  }),
  on(resetCandidatesState, (state) =>
    resetPaginationState<CandidatesState, Candidate>(state, candidatesAdapter),
  ),
  on(loadCandidatesError, loadChatbotResultsError, (state) => ({
    ...state,
    pagination: {
      ...state.pagination,
      loading: false,
    },
  })),
  on(deleteCandidate, (state, { payload }) => {
    return handleRemoveOneAction(state, payload.candidateId, candidatesAdapter);
  }),
  on(loadAiSummariesSuccess, (state, { payload }) => ({
    ...state,
    candidateSummaries: {
      ...state.candidateSummaries,
      [payload.summary.candidateId]: payload.summary.summary,
    },
  })),
  on(setStatusId, (state, { payload }) => ({
    ...state,
    statusId: payload.statusId,
  })),
);
